import { domain as globalDomain } from '@utils/domain';

export const domain = globalDomain.domain('@userService');
